// extracted by mini-css-extract-plugin
module.exports = {"tablet":"482px","desktop":"1025px"};